var scrollToProducts = true;
if (typeof string == 'undefined') {
    var string = '';
}
if (typeof urlChain == 'undefined') {
    var urlChain = '';
}
if (typeof loadProductsType == 'undefined') {
    var loadProductsType = '';
}

function loadProducts(callback) {
    history.pushState(null, null, current_url + (loadProductsType == 'search' ? '&' : '?') + 'pagination_page='+pagination_page+(filters.length > 0 ? '&filters='+JSON.stringify(filters) : '')+(numFilters.length > 0 ? '&numFilters='+JSON.stringify(numFilters) : '')+'&sort='+sort);
    // if (numFilters.length > 0 || filters.length > 0) {
    //     $('.sidebar__reset').removeClass('d-none');
    // } else {
    //     $('.sidebar__reset').addClass('d-none');
    // }
    // $('#loader').removeClass('d-none');
    // $('.load-more').addClass('d-none');
    // $('.load-more').removeClass('d-flex');
    let loader = '<div data-js="loader-load-more" class="mb-md-4 col-12 col-sm-12 D(f) Jc(c)"><img src="/assets/svg/spin-1.1s-100px.svg" alt="loading" style="height: 90px;"></div>'
    $('.js-article-set-wrapper').append(loader);
    $.post(url__load+'?v='+uniqid(), {
        pagination_page: pagination_page,
        _route: _route,
        urlChain: urlChain,
        string: string,
        article_total: article_total,
        pagination_total: pagination_total,
        pagination_size: pagination_size,
        pagination_route: pagination_route,
        filters: filters,
        numFilters: numFilters,
        type: loadProductsType
    }, function (data) {
        article_total = data.attributes.article_total;
        pagination_total = data.attributes.pagination_total;
        pagination_size = data.attributes.pagination_size;
        pagination_route = data.attributes.pagination_route;
        console.log(data.articles);
        if (data.articles) {
          tagManager_impression(data.articles, (loadProductsType == 'search' ? 'search' : 'catalog '.urlChain));
        }

        // $('#article-total-text').text((data.totalArticles > 1 || data.totalArticles == 0) ? string_products : string_product);
        // $('#article-total').text(data.totalArticles);
        // $('#loader').addClass('d-none');
        // if (data.showLoadMore) {
        //     $('.load-more').removeClass('d-none');
        //     $('.load-more').addClass('d-flex');
        // }
        callback(data);
    });
}

// CARICA ALTRI

$(document).on('click', '.js-pagination-item', function (e) {
    // e.preventDefault();
    pagination_page = $(this).attr('data-page');
    // $('.js-pagination-item').attr('data-page', +$('.js-pagination-item').attr('data-page') + 1);
    $(this).hide();
    loadProducts(function (data) {
        // scrollToStart('article-set-wrapper');
        $('[data-js="loader-load-more"]').remove();
        
        $('.js-pagination').html(data.html.pagination);
        $('.js-article-set-wrapper').html($('.js-article-set-wrapper').html() + data.html.results);
    });
});

// FILTRI NUMERICI (MISURE ECC...)

var numFiltersKeyupToken = null;
$('.js-num-filters').on('keyup', function (e) {
    numFiltersKeyupToken = uniqid();
    var current_numFiltersKeyupToken = numFiltersKeyupToken;
    var element = $(this);
    setTimeout(function () {
        if (current_numFiltersKeyupToken == numFiltersKeyupToken) {
            element.blur();
        }
    }, 3000);
});

$('.js-num-filters').on('change paste', function (e) {

    /**
     * @Todo to maggiore di from
     */

    $('#loader').removeClass('d-none');
    $('#article-wrapper').html('');
    numFiltersKeyupToken = uniqid();
    // console.log(e);
    numFilters = [];
    var items = $('.js-num-filters');
    var length = items.length;
    if (length > 0) {
        items.each(function (k, v) {
            if ($(v).val()) {
                numFilters.push({
                    'key': $(v).attr('data-key'),
                    'value': $(v).val()
                });
            }
            if (!--length) {
                console.log(numFilters);
                pagination_page = 1;
                loadProducts(function (data) {
                    scrollToStart('article-set-wrapper');
                    $('.js-pagination').html(data.html.pagination);
                    $('.js-article-set-wrapper').html(data.html.results);
                });
            }
        });
    } else {
        pagination_page = 1;
        loadProducts(function (data) {
            scrollToStart('article-set-wrapper');
            $('.js-pagination').html(data.html.pagination);
            $('.js-article-set-wrapper').html(data.html.results);
        });
    }
});

// FILTRI TESTUALI (COLORE, FORMA ECC...)

function triggerFiltersChange() {
    console.log('change filter');
    // $('#loader').removeClass('d-none');
    // $('#article-wrapper').html('');
    filters = [];
    var items = $('.js-filter:checked');
    var length = items.length;

    if (length > 0) {
        items.each(function (k, v) {
            filters.push({
                'key': $(v).attr('data-key'),
                'value': $(v).val()
            });
            if (!--length) {
                loadProducts(function (data) {
                    scrollToStart('article-set-wrapper');
                    $('.js-pagination').html(data.html.pagination);
                    $('.js-article-set-wrapper').html(data.html.results);
                });
            }
        });
    } else {
        loadProducts(function (data) {
            scrollToStart('article-set-wrapper');
            $('.js-pagination').html(data.html.pagination);
            $('.js-article-set-wrapper').html(data.html.results);
        });
    }
}

$('.js-filter').on('change', function () {
    pagination_page = 1;
    triggerFiltersChange();
});

// SORT

$('#sort-catalog').change(function () {
    $('#loader').removeClass('d-none');
    $('#article-wrapper').html('');
    sort = $(this).val();
    pagination_page = 1;
    loadProducts(function (data) {
        scrollToStart('article-set-wrapper');
        $('.js-pagination').html(data.html.pagination);
        $('.js-article-set-wrapper').html(data.html.results);
    });
});

function resetFilters() {
    filters = [];
    numFilters = [];
    $('.js-filter:checked').prop('checked', false);
    $('.js-num-filters').val(null);
    $('.js-filterFacilitator').addClass('active');
    setTimeout(function () {
        loadProducts(function (data) {
            scrollToStart('article-set-wrapper');
            $('.js-pagination').html(data.html.pagination);
            $('.js-article-set-wrapper').html(data.html.results);
        });
    }, 500);
}
